import { useAppDispatch, useAppSelector } from 'store/store';
import { EnhancedTabs } from 'components/enhanced/tabs/EnhancedTabs';
import { useIsBottomFromTenantAdmin } from 'shared/permissions/useIsBottomFromTenantAdmin';
import { loadingActions } from 'store';
import toast from 'shared/utils/toast';
import TenantPage from 'layouts/TenantPage';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import SupplierForm from '../components/SupplierForm';
import { ISupplier } from '../types';
import { supplierService } from '../api/SupplierService';

export const EditSupplier = () => {
  const translationPrefix = 'pages.supplier.edit';
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const { supplierId } = useParams();
  const sap_active = useAppSelector((state) => state.auth.sap_active);
  const [supplier, setSupplier] = useState<ISupplier>();
  const isTenantAdminBottom = useIsBottomFromTenantAdmin();

  useEffect(() => {
    supplierService.get(Number(supplierId)).then(setSupplier);
  }, []);

  const updateSupplier = async (values) => {
    if (!supplier) return;
    dispatch(loadingActions.startLoading());
    const data = { ...supplier, ...values };
    delete data.id;
    supplierService.update(supplier.id, data).then((res) => {
      toast.success('Fornitore aggiornato con successo');
      supplierService.get(+supplierId).then(setSupplier);
    });
    dispatch(loadingActions.stopLoading());
  };

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}
      entityCode={supplier?.code + (sap_active ? ` (SAP ID ${supplier?.sap_id})` : '')}>
      <EnhancedTabs
        tabs={[
          {
            label: t(`global.base-info`),
            component: (
              <SupplierForm
                supplier={supplier}
                onSubmit={updateSupplier}
                disableEdit={!isTenantAdminBottom}
              />
            )
          }
        ]}
        variant="scrollable"
        historyConfig={{ service: supplierService, entityId: supplier?.id }}
        documentConfig={{
          serviceName: 'supplier_archive',
          entityId: supplier?.id,
          dictParams: { supplier_archive: supplier?.id },
          folderDescription: `Name: ${supplier?.company_name}; `,
          customFolderName: 'menu.supplier_archives/' + supplier?.code,
          disableEdit: !isTenantAdminBottom,
          isSupplier: true
        }}
      />
    </TenantPage>
  );
};

export default EditSupplier;
